<template>
    <div>
        <itens-despesas
            :itens="itens"
        ></itens-despesas>
        <rateios-em-massa
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
            @obterUnidades="$emit('obterUnidades')"
            @obterProjetos="$emit('obterProjetos', $event)"
            @obterAcoes="$emit('obterAcoes', $event)"
            @salvarRateios="$emit('salvarRateios', $event)"
        ></rateios-em-massa>
    </div>
</template>

<script>

import ItensDespesas from './ItensDespesas.vue';
import RateiosEmMassa from './RateiosEmMassa.vue';

export default {
    props: {
        itens: {
            type: Array,
            default: () => {[]}
        },

        unidades: {
            type: Array
        }, 

        projetos: {
            type: Array
        }, 
        
        acoes: {
            type: Array
        }
    },

    components: {
        ItensDespesas,
        RateiosEmMassa
    },

    methods: {

    },

    computed: {
        
    }
}

</script>